// Which mask look a live hero's rig wears — one rule for everything drawn as the hero (fx.ts's statuses()
// on her rig, wolfFormView.ts on the wolf standing in for Волчица). Пергаментный плащ reuses the ghost contour
// Финт's invulnerability window has — cloak is untargetable, and "can't be hit" must read the same on sight —
// Без отражения's silhouette included, for both teams. Слиться's shade is its own look: she can be hit, she
// just can't be seen by the other side. Under Наваждение (`confused`: the viewer is deluded) every other
// hero is drawn in the other team's colours.
import type { MaskLook } from './engrave.js';
import type { GameView, ViewHero } from './gameView.js';

export type HeroLook = { look: MaskLook; swap: boolean; key: string };

export function heroMaskLook(view: GameView, h: ViewHero, confused: boolean): HeroLook {
  const st = view.statusOf(h);
  const look: MaskLook = st.invulnerable || st.cloaked || st.silhouette ? 'ghost' : st.invisible ? 'shade' : 'normal';
  const swap = confused && h !== view.player;
  return { look, swap, key: look + (swap ? '+swap' : '') };
}
